exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_header {\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 2rem; }\n\n.hidePag {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/listagem-permissoes/listagem-permissoes.component.scss
// module id = ../../../../../src/app/listagem-permissoes/listagem-permissoes.component.scss
// module chunks = main